import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

export interface AdminProjectIdeaFormGroup {
  state: FormControl<number | null>;
  foundingMode: FormControl<number | null>;
  investmentClassification: FormControl<string | null>;
  loanTerm: FormControl<number | null>;
  loanTypePaymentStart: FormControl<string | null>;
  loanTypePaymentEnd: FormControl<string | null>;
  startCollectionDate: FormControl<string | null>;
  endCollectionDate: FormControl<string | null>;
  contactId: FormControl<string | null>;
}

export function getAdminProjectIdeaFormGroup(
  fb: FormBuilder
): FormGroup<AdminProjectIdeaFormGroup> {
  return fb.nonNullable.group({
    state: fb.control<number | null>(null),
    foundingMode: fb.control<number | null>(null, {
      validators: [Validators.required],
    }),
    investmentClassification: fb.control<string | null>(null, {
      validators: [Validators.required],
    }),
    loanTerm: fb.control<number | null>(null, {
      validators: [Validators.required],
    }),
    loanTypePaymentStart: fb.control<string | null>(null, {
      validators: [Validators.required],
    }),
    loanTypePaymentEnd: fb.control<string | null>(null, {
      validators: [Validators.required],
    }),
    startCollectionDate: fb.control<string | null>(null),
    endCollectionDate: fb.control<string | null>(null),
    contactId: fb.control<string | null>(null, {
      validators: [Validators.required],
    }),
  });
}
